module.exports = __webpack_public_path__ + "img/underground_voltage_fault.dc0346b8.svg";